export function chatConversationIdFromAlert(alert) {
  const url = alert?.navigation_url || "";
  const match = url.match(/\/conversations\/([^/?]+)/);
  return match ? match[1] : null;
}

export default function alertNavigationPath(alert) {
  if (!alert) return "";

  if (chatConversationIdFromAlert(alert)) return "";

  const url = alert.navigation_url || "";

  const evaluateMatch = url.match(/assessment_id=([^&]+)/);
  if (evaluateMatch) {
    return `/assessments/${evaluateMatch[1]}`;
  }

  const orgMatch = url.match(/\/organizations\/[^/]+\/assessments\/([^/?]+)/);
  if (orgMatch) {
    return `/assessments/${orgMatch[1]}`;
  }

  return url;
}
